var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _vm._m(0),
      _vm.isInitialLoading
        ? _c(
            "div",
            {
              staticClass:
                "glass-card loading-container flex flex-column justify-center align-center",
            },
            [
              _c("i", {
                staticClass: "el-icon-loading",
                staticStyle: {
                  "font-size": "40px",
                  color: "#3b82f6",
                  "margin-bottom": "12px",
                },
              }),
              _c(
                "p",
                { staticStyle: { color: "#64748b", "font-weight": "600" } },
                [_vm._v("Đang tải thông tin cấu hình Merchant...")]
              ),
            ]
          )
        : _c(
            "div",
            { staticClass: "glass-card panel-container" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "sk-tabs",
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "keywords" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-collection-tag" }),
                        _vm._v(" Từ khóa Giao dịch\n        "),
                      ]),
                      _c("div", { staticClass: "tab-inner-content" }, [
                        _c(
                          "div",
                          { staticClass: "hint-panel blue-hint mb-4" },
                          [
                            _c("div", { staticClass: "hint-title" }, [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " Cơ chế lọc giao dịch tự động\n            "
                              ),
                            ]),
                            _c("ul", { staticClass: "hint-list" }, [
                              _c("li", [
                                _vm._v(
                                  "Hệ thống sử dụng danh sách từ khóa bên dưới để lọc giao dịch trước khi kích hoạt gửi webhook."
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "Chỉ các giao dịch có nội dung (transaction_content) chứa ít nhất một từ khóa mới được gửi webhook."
                                ),
                              ]),
                              _c("li", [
                                _vm._v("Hệ thống "),
                                _c("strong", [
                                  _vm._v("không phân biệt chữ hoa, chữ thường"),
                                ]),
                                _vm._v(" khi so khớp."),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "Nếu danh sách từ khóa rỗng, tất cả các giao dịch phát sinh sẽ tự động được gửi webhook."
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "example-box mt-2" }, [
                              _c("span", { staticClass: "ex-label" }, [
                                _vm._v("Ví dụ cấu hình:"),
                              ]),
                              _c("span", { staticClass: "ex-text" }, [
                                _vm._v("Từ khóa "),
                                _c("code", [
                                  _vm._v('["thanh toan", "payment"]'),
                                ]),
                                _vm._v(" sẽ chấp nhận "),
                                _c("code", [
                                  _vm._v('"Chuyen khoan thanh toan don hang"'),
                                ]),
                                _vm._v(" và từ chối "),
                                _c("code", [_vm._v('"Chuyen khoan cho ban"')]),
                                _vm._v("."),
                              ]),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "keywords-list-section" }, [
                          _c("h3", { staticClass: "section-title" }, [
                            _vm._v("Danh sách từ khóa Whitelist"),
                          ]),
                          _vm.config.transaction_whitelist_remark_keywords
                            .length === 0
                            ? _c(
                                "div",
                                { staticClass: "empty-state-card mb-4" },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-document-delete",
                                  }),
                                  _c("p", { staticClass: "empty-text" }, [
                                    _vm._v(
                                      "Chưa có từ khóa nào được thiết lập. Hệ thống sẽ cho phép gửi webhook cho tất cả giao dịch."
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                "div",
                                { staticClass: "keywords-grid mb-4" },
                                _vm._l(
                                  _vm.config
                                    .transaction_whitelist_remark_keywords,
                                  function (keyword, index) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: index,
                                        staticClass: "modern-tag-chip",
                                        attrs: {
                                          closable: "",
                                          type: "primary",
                                          size: "medium",
                                        },
                                        on: {
                                          close: function ($event) {
                                            return _vm.removeKeywordFromConfig(
                                              index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(keyword) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                          _c(
                            "div",
                            { staticClass: "action-row" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "gradient-btn-small blue",
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                  },
                                  on: { click: _vm.showAddKeywordDialog },
                                },
                                [
                                  _vm._v(
                                    "\n                Thêm từ khóa mới\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "logo" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-picture-outline" }),
                        _vm._v(" Quản lý Logo hóa đơn\n        "),
                      ]),
                      _c("div", { staticClass: "tab-inner-content" }, [
                        _c(
                          "div",
                          { staticClass: "hint-panel orange-hint mb-4" },
                          [
                            _c("div", { staticClass: "hint-title" }, [
                              _c("i", { staticClass: "el-icon-warning" }),
                              _vm._v(
                                " Quy định tải lên Logo Merchant\n            "
                              ),
                            ]),
                            _c("ul", { staticClass: "hint-list" }, [
                              _c("li", [
                                _vm._v(
                                  "Logo sẽ được hiển thị trên thanh tiêu đề của liên kết thanh toán hosted-link WebView."
                                ),
                              ]),
                              _c("li", [
                                _vm._v(
                                  "Ảnh sau khi tải lên được lưu trữ trên S3 cloud và áp dụng tức thì trên mọi liên kết của hệ thống."
                                ),
                              ]),
                              _c("li", [
                                _vm._v("Định dạng tệp tin cho phép: "),
                                _c("strong", [_vm._v("Chỉ JPG hoặc PNG")]),
                                _vm._v(" (không hỗ trợ SVG, GIF, WebP)."),
                              ]),
                              _c("li", [
                                _vm._v("Dung lượng tệp tối đa: "),
                                _c("strong", [_vm._v("1MB")]),
                                _vm._v(
                                  " (1,048,576 bytes). Tệp vượt quá dung lượng sẽ bị API từ chối."
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "warning-box mt-2" }, [
                              _c("span", { staticClass: "warn-label" }, [
                                _vm._v("⚠️ Lưu ý:"),
                              ]),
                              _c("span", { staticClass: "warn-text" }, [
                                _vm._v(
                                  "Tải lên logo mới sẽ ghi đè và xóa hoàn toàn logo cũ, không thể hoàn tác."
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "logo-config-grid" }, [
                          _c("div", { staticClass: "logo-display-card" }, [
                            _c("h3", { staticClass: "section-title" }, [
                              _vm._v("Logo hiện tại"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "logo-frame" },
                              [
                                _vm.config.logo_url
                                  ? _c(
                                      "el-image",
                                      {
                                        staticClass: "current-logo-img",
                                        attrs: {
                                          src: _vm.config.logo_url,
                                          fit: "contain",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-error-slot",
                                            attrs: { slot: "error" },
                                            slot: "error",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-picture-outline",
                                            }),
                                            _c("span", [
                                              _vm._v("Lỗi tải logo"),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c("div", { staticClass: "no-logo-slot" }, [
                                      _c("i", {
                                        staticClass: "el-icon-picture",
                                      }),
                                      _c("span", [
                                        _vm._v("Chưa cấu hình Logo"),
                                      ]),
                                    ]),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "logo-upload-controls" },
                            [
                              _c("h3", { staticClass: "section-title" }, [
                                _vm._v("Upload Logo mới"),
                              ]),
                              _c(
                                "el-upload",
                                {
                                  ref: "logoUpload",
                                  staticClass: "modern-logo-uploader mb-3",
                                  attrs: {
                                    action: "#",
                                    "auto-upload": false,
                                    "on-change": _vm.handleLogoChange,
                                    "on-remove": _vm.handleLogoRemove,
                                    limit: 1,
                                    accept: ".jpg,.jpeg,.png",
                                    "list-type": "picture",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "small",
                                        type: "primary",
                                        icon: "el-icon-folder-opened",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Chọn tệp logo mới\n                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Chỉ hỗ trợ tệp JPG/PNG, kích thước tối đa 1MB.\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.logoFile
                                ? _c(
                                    "div",
                                    { staticClass: "file-preview-card mb-3" },
                                    [
                                      _c(
                                        "h4",
                                        { staticClass: "preview-title" },
                                        [_vm._v("Xem trước tệp chọn")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "preview-inner" },
                                        [
                                          _vm.logoPreview
                                            ? _c("el-image", {
                                                staticClass:
                                                  "preview-img-frame",
                                                attrs: {
                                                  src: _vm.logoPreview,
                                                  fit: "contain",
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "preview-info" },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "info-row" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Tên file:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.logoFile.name)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "info-row" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Dung lượng:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatFileSize(
                                                          _vm.logoFile.size
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "info-row" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Định dạng:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.logoFile.type)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "action-row pt-2" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "gradient-btn-small green",
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-upload",
                                        loading: _vm.isUploadingLogo,
                                        disabled: !_vm.logoFile,
                                      },
                                      on: { click: _vm.uploadLogoFile },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Bắt đầu tải lên\n                "
                                      ),
                                    ]
                                  ),
                                  _vm.logoFile
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "cancel-upload-btn",
                                          on: { click: _vm.resetLogoUpload },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Hủy bỏ\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "sepay-token", lazy: "" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-key" }),
                        _vm._v(" Thông tin SePay\n        "),
                      ]),
                      _c("se-pay-token-detail"),
                    ],
                    2
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { name: "sepay-ips", lazy: "" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("i", { staticClass: "el-icon-connection" }),
                        _vm._v(" IP được chấp nhận\n        "),
                      ]),
                      _c("se-pay-allowed-ip-management"),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "THÊM TỪ KHÓA GIAO DỊCH",
            visible: _vm.dialogAddKeyword,
            width: "550px",
            "custom-class": "modern-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAddKeyword = $event
            },
            close: _vm.resetAddKeywordForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formAddKeyword",
              attrs: { model: _vm.formKeyword, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      "Từ khóa Whitelist (ví dụ: 'hoc phi', 'thanh toan', 'chuyen khoan')",
                    prop: "keyword",
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "modern-input-large",
                    attrs: {
                      placeholder: "Nhập từ khóa giao dịch...",
                      "prefix-icon": "el-icon-edit",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.addKeyword.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.formKeyword.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.formKeyword, "keyword", $$v)
                      },
                      expression: "formKeyword.keyword",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogAddKeyword = false
                    },
                  },
                },
                [_vm._v("Hủy bỏ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn-small blue",
                  attrs: { type: "primary", loading: _vm.isSavingKeyword },
                  on: { click: _vm.addKeyword },
                },
                [_vm._v("\n        Xác nhận thêm\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _c("div", { staticClass: "banner-left" }, [
          _c("div", { staticClass: "ai-icon-pulse" }, [
            _c("i", { staticClass: "el-icon-setting" }),
          ]),
          _c("div", [
            _c("h1", { staticClass: "banner-title" }, [
              _vm._v("QUẢN LÝ CẤU HÌNH MERCHANT"),
            ]),
            _c("p", { staticClass: "banner-subtitle" }, [
              _vm._v(
                "Quản lý từ khóa giao dịch, Logo, thông tin kết nối SePay và danh sách IP được chấp nhận."
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }